<template>
  <div class="study-abstract">
    <div class="outline" v-for="(item, index) in list" :key="index">
      <div>
        <img :src="item.status|playerOrLock" alt="" class="player">
        <div class="abstract">
          <p class="title">{{item.title}}<span v-if="item.status===1">试听</span></p>
          <p class="sub-title">{{item.subTitle}}</p>
        </div>
      </div>
      <img src="/images/omit.png" alt="">
    </div>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data(){
    return {}
  },
  filters: {
    playerOrLock (params) {
      return params === 1 ? '/images/study_player.png' : '/images/study_lock.png'
    }
  },
  created(){}
}
</script>

<style scoped>
.outline{
  height: 67px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #F0FEFF;
}
.outline:last-of-type{
  border-bottom: none;
}
.outline .player{
  height: 24px;
  width: 24px;
  margin-right: 10px;
}
.outline .abstract{
  display: inline-block;
}
.abstract .title {
  height:22px;
  font-size:16px;
  font-weight:bold;
  color:rgba(102,102,102,1);
  line-height:22px;
  margin-bottom: 4px;
}
.abstract .title>span{
  margin-left: 9px;
  display: inline-block;
  padding: 2px 7px 0;
  height:17px;
  line-height:17px;
  text-align: center;
  background:#ebf3fe;
  border-radius:6px;
  color: #3F8DFD;
  font-size:12px;
}
.abstract .sub-title{
  height:17px;
  font-size:12px;
  font-weight:500;
  color:rgba(153,153,153,1);
  line-height:17px;
}
</style>
